/**
 * Private app distribution + redemption codes.
 *
 * CCMS mobile apps are distributed privately — a user cannot find them by searching
 * the App Store or Play Store. Apple ships via Apple Business Manager custom-app
 * redemption codes; Android ships via an install link (Google Play has no promo codes
 * for free apps). These models back the admin distribution screens and the user's
 * "Get the Apps" download page.
 *
 * Mirrors `catalogue.app_distributions` / `app_codes` / `app_code_events` (migration 194).
 */
/** Platform ids from the seeded `catalogue.app_platforms` lookup. */
export const APP_PLATFORM = {
    IOS: 1,
    ANDROID: 2,
};
/**
 * Code lifecycle ids from `catalogue.code_statuses`.
 *
 * REDEEMED / REVOKED / EXPIRED / INVALID are TERMINAL. A redemption code is
 * single-use: once it has been redeemed it is spent, and it can never be revoked,
 * unassigned or reset. The only thing left to know about it is that it was used.
 */
export const CODE_STATUS = {
    AVAILABLE: 1,
    ASSIGNED: 2,
    REDEEMED: 3,
    REVOKED: 4,
    EXPIRED: 5,
    INVALID: 6,
};
/** True once a code can never change state again. */
export function isTerminalCodeStatus(statusId) {
    return (statusId === CODE_STATUS.REDEEMED ||
        statusId === CODE_STATUS.REVOKED ||
        statusId === CODE_STATUS.EXPIRED ||
        statusId === CODE_STATUS.INVALID);
}
//# sourceMappingURL=AppDistribution.js.map